import { useDynamicConfig } from '@statsig/react-bindings';

import { EventType } from '@/analytics/types';

import type { DiscountDifferenceData } from './HolidayHeroTemplate25';
import SDBFCMHeroTemplate2025 from './HolidayHeroTemplate25';

const BFCM = () => {
  const discountDifferenceData = useDynamicConfig(
    'bfcm_hero_title_price',
  ).value;

  return (
    <SDBFCMHeroTemplate2025
      discountDifferenceData={
        discountDifferenceData as unknown as DiscountDifferenceData
      }
      tagMsgKey="black_friday_sale"
      titleMsgKey="singles_day_hero_title"
      subcopyMsgKey="bf_dont_sleep_on_sale"
      buttonProps={{
        href: '/store/rings/oura-ring-4/silver',
        ctaLabel: 'shop_sale',
        onClick: () => {
          void window.ouraAnalytics.track(EventType.CTAClicked, {
            cta: 'shop sale',
            action: 'go to pdp',
            location: 'hero',
            path: '/store/rings/oura-ring-4/silver',
          });
        },
      }}
    />
  );
};
export default BFCM;
